/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_add': {
    width: 16,
    height: 16,
    viewBox: '0 0 35.55 41',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path pid="0" d="M18.45 40H1V1h33.55v23.72M23.89 34.67h10.66M29.22 29.34V40"/><path pid="1" d="M7.54 20.5l6.41-9.03 6.25 7.25 6.82-9.62"/></g></g>'
  }
})
